import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Layout from "./components/Layout";
import Eventos from "./components/Eventos";
import Cultura from "./components/Cultura";
import Recomendaciones from "./components/Recomendaciones";
import ContactForm from "./components/ContactForm";
import TallerDetalle from "./components/TallerDetalle";
import EventoDetalle from "./components/EventoDetalle";
import RecomendacionDetalle from "./components/RecomendacionDetalle";
import AdminRoute from "./components/admin/AdminRoute";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/admin" element={<AdminRoute />} />
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/eventos" element={<Eventos />} />
              <Route path="/cultura" element={<Cultura />} />
              <Route path="/recomendaciones" element={<Recomendaciones />} />
              <Route path="/contacto" element={<ContactForm />} />
              <Route path="/actividad/:slug" element={<TallerDetalle />} />
              <Route path="/evento/:slug" element={<EventoDetalle />} />
              <Route path="/recomendacion/:slug" element={<RecomendacionDetalle />} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Router>
  );
}

export default App;
